import { render } from "./Staked.vue?vue&type=template&id=7f2752b3"
import script from "./Staked.vue?vue&type=script&lang=js"
export * from "./Staked.vue?vue&type=script&lang=js"

import "./Staked.vue?vue&type=style&index=0&id=7f2752b3&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/weapsmithing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__